import React, { Component } from "react";
import { connect } from "react-redux";
import backlogo from "../../assets/images/svg/Back.svg";
import { Link } from "react-router-dom";
import { FormGroup, Button, Label, Input } from "reactstrap";
import Select from "react-select";
import { removeEmojis } from "../ReusableComponent/RemoveEmoji";
import SweetAlert from "react-bootstrap-sweetalert";
import GeneViewList from "./GeneViewList";
import axiosInstance from "../configuration/Request";
import Loader from "react-loaders";
import { showErrorToast } from "../Components/Toaster";
import { ToastContainer } from "react-toastify";
import {
  SIGNIFICANT_OPTIONS,
  CENTRALITYOPTIONS,
  TUMORIGENESIS_PAIRED_OPTIONS
} from "./../../constant/furtherAnalysis";
import { setFurtureAnalysis } from "../../reducers/counterSlice";
import LesserThan from "../../../src/assets/images/png/icons8-less-than-60.png"
import GreaterThan from "../../../src/assets/images/png/icons8-greater-than-60.png"

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
  };
};

const mapDispatchToProps = {
  setFurtureAnalysis
};

const customStyles = {
  option: (provided) => ({
    ...provided,
    display: 'flex',
    alignItems: 'center',
  }),
};

const optionsLesserOrGreater = [
  {
    value: 'low',
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={LesserThan} alt="Less than" style={{ width: '15px', height: '15px' }} />
      </div>
    )
  },
  {
    value: 'high',
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={GreaterThan} alt="Greater than" style={{ width: '15px', height: '15px' }} />
      </div>
    )
  }
];

const selectStyles = {
  control: (baseStyles) => ({
    ...baseStyles,
    height: "40px",
    cursor: "pointer",
  }),
  option: (base) => ({
    ...base,
    cursor: "pointer",
    fontSize: "14px",
    paddingLeft: "30px",
  }),
  groupHeading: (base) => ({
    ...base,
    fontSize: "14px",
    color: "#000000",
  }),
};


class FurtherAnalysis extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      inputValues: {},
      selectedOperator: "AND",
      selectedComparisonTumorigenesis: "lt",
      selectedComparisonSurvival: "lt",
      selectedCentrality: null,
      selectedPathway: null,
      selectedCancerType: null,
      significantCondition: "Not Conflict",
      openViewList: false,
      cancerTypeOptions: [],
      pathwayOptions: [],
      topValue: "",
      loader: false,
      filters: {
        Tumorigenesis: {
          selected: false,
          fdr: "",
          fold_change: "",
          fc_threshold: "low",
          isParied: "true"
        },
        Survival: {
          selected: false,
          hazard_ratio: "",
          hr_threshold: "low",
        },
        Proliferation: {
          selected: false,
          sig_percent_crispr: "",
          sig_percent_rnai: "",
          sig_condition: "AND",
        },
        Drug_Sensitivity: {
          selected: false,
        },
      },
      viewData: {
        type: "",
        viewDetails: {},
      },
      optionLoader: false,
      isFromProject: false, // Track if coming from Project table
    };
    this.state = this.initialState;
  }

  componentDidMount() {
    // Set isFromProject from Redux
    const isFromProject = this.props.reduxData.networkForAnalysis.isFromProject || false;
    this.setState({ isFromProject });

    if (this.props.reduxData.networkForAnalysis.histologicalSubtype) {
      this.setState(
        {
          selectedCancerType: {
            value: this.props.reduxData.networkForAnalysis.histologicalSubtype,
            label: this.props.reduxData.networkForAnalysis.histologicalSubtype,
            cancer_type: this.props.reduxData.networkForAnalysis.cancerType,
          },
        },
      );
    }
    this.fetchCancerType();
  }
  fetchCancerType = (dropdownData) => {
    this.setState({ loader: true });

    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}api/network-dropdowns?filter=true`)
      .then((res) => {
        const data = res?.data || {};
        const cancerType = this.processCancerType(data?.dropdownData);
        this.setState({
          cancerTypeOptions: cancerType,
        });
      })
      .catch((err) => console.log(err))
      .finally(() => this.setState({ loader: false }));
  }

  processCancerType = (dropdownData) => {
    return (
      dropdownData
        ?.filter((item) => item?.cancer_type)
        .map((item) => ({
          label: item.cancer_type,
          options: item?.histological_subtypes
            ?.filter((subtype) => subtype !== null)
            .map((subtype) => ({
              value: subtype,
              label: subtype,
              cancer_type: item.cancer_type,
            })),
        })) || []
    );
  };

  handleRadioChange = (label) => {
    this.setState({ significantCondition: label });
  };

  handleRadioTumorigensisIsPairedOptionChange = (value) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        Tumorigenesis: {
          ...prevState.filters.Tumorigenesis,
          isParied: value
        }
      }
    }));
  };

  handleSelectChange = (selectedOption, type) => {
    this.setState({ [type]: selectedOption });
    if (!selectedOption && type === "selectedCentrality") {
      this.setState({ topValue: "" });

    }
  };

  handleCheckboxChange = (label) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        [label]: {
          ...prevState.filters[label],
          selected: !prevState.filters[label].selected,
        },
      },
    }));
  };

  handleValueChange = (event, label, field) => {
    const { value } = event.target;
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        [label]: {
          ...prevState.filters[label],
          [field]: value,
        },
      },
    }));
  };

  handlePathwaySearch = (inputValue) => {
    if (inputValue !== "") {
      this.setState({ optionLoader: true });
      axiosInstance
        .get(`${process.env.REACT_APP_BASE_URL}api/further-analysis/get-unique-geneSet?geneSet=${inputValue}`)
        .then((res) => {
          const data = res?.data || {};
          const patwaysData = data?.geneSets?.map((item) => ({
            label: item,
            value: item,
          })) || []

          this.setState({
            pathwayOptions: patwaysData,
            optionLoader: false
          });
        })
        .catch((err) => console.log(err))
        .finally(() => this.setState({ optionLoader: false }));
    }

  }

  topValueChange = (event) => {
    const filteredValue = removeEmojis(event.target.value);
    this.setState({ topValue: filteredValue });
  };

  validateInputs = (actionType, requireCheckboxSelection = false) => {
    const isAnyCheckboxSelected = Object.values(this.state.filters).some(
      (filter) => filter.selected
    );

    if (!this.state.selectedCancerType && (!isAnyCheckboxSelected && requireCheckboxSelection)) {
      showErrorToast(`Please select at least one checkbox and cancer type to ${actionType}`);
      return false;
    }

    if (!this.state.selectedCancerType) {
      showErrorToast(`Please select cancer type to ${actionType}`);
      return false;
    }

    if (requireCheckboxSelection && !isAnyCheckboxSelected) {
      showErrorToast(`Please select at least one checkbox to ${actionType}`);
      return false;
    }

    return true;
  };

  handleViewClick = (label) => {
    const requireCheckboxSelection = label === "Significant_Condition";

    if (!this.validateInputs("view List", requireCheckboxSelection)) return;

    this.setState({
      openViewList: true,
      viewData: {
        type: label,
        viewDetails: this.state.filters,
        cancerType: this.state.selectedCancerType.cancer_type,
        histological_subtype: this.state.selectedCancerType.label,
        networkId: this.props.reduxData.networkForAnalysis.networkId,
        significantCondition: this.state.significantCondition.toLowerCase(),
        centrality: this.state?.selectedCentrality?.value,
        top_percentage: this.state.topValue === "" ? "" : Number(this.state.topValue),
        pathway: this.state.selectedPathway?.value,
        isFromProject: this.state.isFromProject, // Pass flag for View List API calls
      },
    });
  };


  handleRun = () => {
    if (!this.validateInputs("run the analysis", true)) return;

    this.props.setFurtureAnalysis({
      viewDetails: this.state.filters,
      significantCondition: this.state.significantCondition.toLowerCase(),
      pathway: this.state.selectedPathway?.value,
      top_percentage: this.state.topValue === "" ? "" : Number(this.state.topValue),
      cancerType: this.state.selectedCancerType.cancer_type,
      centrality: this.state.selectedCentrality?.value,
      histological_subtype: this.state.selectedCancerType.label,
      networkId: this.props.reduxData.networkForAnalysis.networkId,
      isFromProject: this.state.isFromProject, // Pass flag to analysis result
    });

    this.props.history.push(`/app/discover/analysisResult?activeTab=${new URLSearchParams(this.props.location.search).get('activeTab') || 'networks'}`);
  };


  handleClear = () => {
    const { cancerTypeOptions } = this.state;
    this.setState(
      {
        ...this.initialState,
        cancerTypeOptions,
      }
    );
  };

  closePopup = () => {
    this.setState({
      openViewList: false,
    });
  };

  handleNumericInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  };

  render() {
    return (
      <div className="outer-container-analysis">
        <ToastContainer />
        <div className="main-container-analysis">
          <div className="top-container-analysis">
            <Link
              className="btn-link-primary"
              to={{ pathname: "/app/discover/myProject", search: `?activeTab=${new URLSearchParams(this.props.location.search).get('activeTab') || 'networks'}` }}
            >
              <div className="d-inline-flex">
                <img src={backlogo} alt="" />
                <span
                  style={{ color: "#333333", fontWeight: 400 }}
                  className="ms-1"
                >
                  Back
                </span>
              </div>
            </Link>

            <div className="title-div fw-bold d-flex align-items-center mt-2">
              Analysis Selection
            </div>
            <div className="network-form-container">
              <div className="cancer-type mt-1  ms-1" style={{ width: "40%" }}>
                <FormGroup>
                  <Label>Cancer Type</Label>
                  <Select
                    styles={selectStyles}
                    value={this.state.selectedCancerType}
                    onChange={(e) =>
                      this.handleSelectChange(e, "selectedCancerType")
                    }
                    options={this.state.cancerTypeOptions}
                    placeholder="Select Cancer Type"
                  />
                </FormGroup>
              </div>
              <hr style={{ width: "100%" }} />
              <div className="mt-3 ms-1" style={{ color: "black", fontSize: "13px" }}>
                Note: At least one of <strong>Tumorigenesis</strong>, <strong>Survival</strong>,
                <strong> Proliferation</strong>, or <strong>Drug Sensitivity</strong> must be selected
                to proceed with the analysis.
              </div>
              <div>
                {["TCGA", "CCLE"].map((category) => (
                  <div className="category-box mt-4 ms-1" key={category}>
                    <div className="sub-title">{category}</div>

                    {Object.entries(this.state.filters)
                      .filter(
                        ([label]) =>
                          (category === "TCGA" &&
                            ["Tumorigenesis", "Survival"].includes(label)) ||
                          (category === "CCLE" &&
                            ["Proliferation", "Drug_Sensitivity"].includes(
                              label
                            ))
                      )
                      .map(([label, data]) => (
                        <div className="filter-box mt-2 " key={label}>
                          {/* Checkbox */}
                          <div style={{ width: "150px" }}>
                            <FormGroup check>
                              <Input
                                type="checkbox"
                                id={`checkbox-${label}`}
                                onChange={() =>
                                  this.handleCheckboxChange(label)
                                }
                                checked={data.selected}
                              />
                              <Label
                                for={`checkbox-${label}`}
                                check
                                style={{ color: "black", fontSize: "14px" }}
                                className="checkbox-label ms-1"
                              >
                                {label.replace("_", " ")}
                              </Label>
                            </FormGroup>
                          </div>

                          {/* Filters */}
                          <div className="filter-outer d-flex">
                            <div>
                              {label === "Tumorigenesis" && (
                                <div>
                                  <div className="filter-group">
                                    <div className="filter-item">
                                      <div className="filter-input-group">
                                        <span className="operator"><img src={LesserThan} alt="" style={{ width: '15px', height: '15px' }} /></span>
                                        <input
                                          type="text"
                                          className="filter-input"
                                          placeholder="FDR"
                                          value={data.fdr}
                                          onChange={(e) =>
                                            this.handleValueChange(e, label, "fdr")
                                          }
                                          onInput={this.handleNumericInput}
                                        />
                                      </div>
                                    </div>
                                    <span className="and-operator">AND</span>
                                    <div className="filter-item">
                                      <div className="filter-input-group">
                                        <Select
                                          className="filter-dropdown"
                                          value={optionsLesserOrGreater.find(option => option.value === data.fc_threshold)}
                                          onChange={(selectedOption) => {
                                            const syntheticEvent = {
                                              target: {
                                                value: selectedOption.value
                                              }
                                            };
                                            this.handleValueChange(syntheticEvent, label, "fc_threshold");
                                          }}
                                          options={optionsLesserOrGreater}
                                          styles={customStyles}
                                        />
                                        <input
                                          type="text"
                                          className="filter-input-fold-change"
                                          placeholder="Log2 Fold Change"
                                          value={data.fold_change}
                                          onChange={(e) =>
                                            this.handleValueChange(
                                              e,
                                              label,
                                              "fold_change"
                                            )
                                          }
                                          onInput={this.handleNumericInput}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="ms-1">
                                    {TUMORIGENESIS_PAIRED_OPTIONS.map((option, index) => (
                                      <div key={index} className="d-flex align-items-center me-2">
                                        <FormGroup check className="d-flex align-items-center">
                                          <Input
                                            type="radio"
                                            name="tumorigensisRadioGroup"
                                            id={`tumorigensis-radio-${index}`}
                                            value={option.value}
                                            onChange={() =>
                                              this.handleRadioTumorigensisIsPairedOptionChange(option.value)
                                            }
                                            checked={this.state.filters.Tumorigenesis.isParied === option.value}
                                          />
                                          <Label
                                            for={`tumorigensis-radio-${index}`}
                                            check
                                            className="ms-2 mt-1"
                                            style={{ color: "black", fontSize: "14px" }}
                                          >
                                            {option.label}
                                          </Label>
                                        </FormGroup>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}

                              {label === "Survival" && (
                                <div className="filter-group">
                                  <div className="filter-item">
                                    <div className="filter-input-group">
                                      <Select
                                        className="filter-dropdown"
                                        value={optionsLesserOrGreater.find(option => option.value === data.hr_threshold)}
                                        onChange={(selectedOption) => {
                                          const syntheticEvent = {
                                            target: {
                                              value: selectedOption.value
                                            }
                                          };
                                          this.handleValueChange(syntheticEvent, label, "hr_threshold");
                                        }}
                                        options={optionsLesserOrGreater}
                                        styles={customStyles}
                                      />
                                      <input
                                        type="text"
                                        className="filter-input"
                                        placeholder="Hazard Ratio"
                                        value={data.hazard_ratio}
                                        onChange={(e) =>
                                          this.handleValueChange(
                                            e,
                                            label,
                                            "hazard_ratio"
                                          )
                                        }
                                        onInput={this.handleNumericInput}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                              {label === "Proliferation" && (
                                <div className="filter-group">
                                  <div className="filter-item">
                                    <div className="filter-input-group">
                                      <input
                                        type="text"
                                        className="filter-input"
                                        placeholder="CRISPR %"
                                        value={data.sig_percent_crispr}
                                        onChange={(e) =>
                                          this.handleValueChange(
                                            e,
                                            label,
                                            "sig_percent_crispr"
                                          )
                                        }
                                        onInput={this.handleNumericInput}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="filter-input-group"
                                    style={{ marginTop: "2px" }}
                                  >
                                    <select
                                      className="filter-dropdown"
                                      value={data.sig_condition}
                                      onChange={(e) =>
                                        this.handleValueChange(
                                          e,
                                          label,
                                          "sig_condition"
                                        )
                                      }
                                    >
                                      <option value="AND">AND</option>
                                      <option value="OR">OR</option>
                                    </select>
                                  </div>
                                  <div className="filter-item">
                                    <div className="filter-input-group">
                                      <input
                                        type="text"
                                        className="filter-input"
                                        placeholder="RNAi %"
                                        value={data.sig_percent_rnai}
                                        onChange={(e) =>
                                          this.handleValueChange(
                                            e,
                                            label,
                                            "sig_percent_rnai"
                                          )
                                        }
                                        onInput={this.handleNumericInput}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}

                            </div>

                            {/* View List Button */}
                            <div className="view-btn-outer">
                              <Button
                                color="primary"
                                className="view-btn mt-2"
                                onClick={() => this.handleViewClick(label)}
                                disabled={!data.selected}
                              >
                                View List
                              </Button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                ))}

                <div className="mt-4">
                  <div className=" d-flex" style={{ width: "100%" }}>
                    <div className="d-flex flex-wrap ms-1">
                      {SIGNIFICANT_OPTIONS.map((label, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center me-2"
                        >
                          <FormGroup
                            check
                            className="d-flex align-items-center"
                          >
                            <Input
                              type="radio"
                              name="radioGroup"
                              id={`radio-${index}`}
                              value={label}
                              onChange={() => this.handleRadioChange(label)}
                              checked={
                                this.state.significantCondition === label
                              }
                            />
                            <Label
                              for={`radio-${index}`}
                              check
                              className="ms-2 mt-1"
                              style={{ color: "black", fontSize: "14px" }}
                            >
                              {label}
                            </Label>
                          </FormGroup>
                        </div>
                      ))}
                    </div>
                    <div className="view-btn-outer">
                      <Button
                        color="primary"
                        className="view-btn"
                        onClick={(e) => this.handleViewClick("Significant_Condition")}
                        disabled={!this.state.significantCondition}
                      >
                        View List
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <hr style={{ width: "100%" }} />
              {/* Hide Centrality section for Projects */}
              {!this.state.isFromProject && (
                <div className="d-flex ms-1"
                  title={
                    this.props.reduxData?.networkForAnalysis?.networkType === "Operation"
                      ? "Disabled because network is of Operation type"
                      : ""
                  }>
                  <div style={{ width: "40%" }}>
                    <div>
                      <FormGroup>
                        <Select
                          styles={selectStyles}
                          isClearable={true}
                          value={this.state.selectedCentrality}
                          onChange={(e) =>
                            this.handleSelectChange(e, "selectedCentrality")
                          }
                          options={CENTRALITYOPTIONS}
                          placeholder="Select Centrality"
                          isDisabled={this.props.reduxData?.networkForAnalysis?.networkType === "Operation"}
                        />
                      </FormGroup>
                    </div>
                    <div>
                      <FormGroup>
                        <Input
                          id="exampleEmail"
                          name="text"
                          placeholder="Top %"
                          type="text"
                          style={{ height: "40px" }}
                          value={this.state.topValue !== '' ? `${this.state.topValue}%` : ''}
                          minLength={1}
                          maxLength={50}
                          onChange={(e) => {
                            const numericValue = e.target.value.replace(/[^0-9.]/g, '');
                            this.setState({ topValue: numericValue });
                          }}
                          onKeyDown={(e) => {
                            const value = e.target.value;
                            if (e.key === 'Backspace' && value.endsWith('%')) {
                              // If cursor is at the end (after %), adjust the deletion
                              if (e.target.selectionStart === value.length) {
                                e.preventDefault();
                                const newValue = value.slice(0, -2) + '%';
                                e.target.value = newValue;
                                const numericValue = newValue.replace(/%/g, '');
                                this.setState({ topValue: numericValue });
                              }
                            }
                          }}
                          onBlur={(e) => {
                            // Ensure % is always shown when field loses focus
                            if (this.state.topValue !== '' && !e.target.value.endsWith('%')) {
                              e.target.value = `${this.state.topValue}%`;
                            }
                          }}
                          disabled={!this.state.selectedCentrality}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="view-btn-outer">
                    <Button
                      color="primary"
                      className="view-btn ms-5"
                      onClick={(e) => this.handleViewClick("Centrality")}
                      disabled={!this.state.selectedCentrality}
                    >
                      View List
                    </Button>
                  </div>
                </div>
              )}
              <hr style={{ width: "100%" }} />
              <div className="d-flex ms-1 mb-3">
                <div style={{ width: "40%" }}>
                  <FormGroup className="analysis-select">
                    <Select
                      styles={selectStyles}
                      isClearable={true}
                      value={this.state.selectedPathway}
                      options={this.state.pathwayOptions}
                      onChange={(e) =>
                        this.handleSelectChange(e, "selectedPathway")
                      }
                      placeholder="Pathway"
                      onInputChange={(inputValue) => this.handlePathwaySearch(inputValue)}
                      isLoading={this.state.optionLoader}
                    />
                  </FormGroup>
                </div>
                <div className="view-btn-outer">
                  <Button
                    color="primary"
                    className="view-btn ms-5"
                    onClick={(e) => this.handleViewClick("Pathway")}
                    disabled={!this.state.selectedPathway}
                  >
                    View List
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-container-further">
            <Button
              className="clear-button-further"
              color="light"
              onClick={() => this.handleClear()}
            >
              Clear
            </Button>
            <Button
              className="next-button-further ms-2"
              color="primary"
              onClick={() => this.handleRun()}
            >
              Run
            </Button>
          </div>
        </div>
        <SweetAlert
          custom
          show={this.state.openViewList}
          customButtons={<React.Fragment></React.Fragment>}
          style={{ width: "auto", padding: "1rem" }}
        >
          <GeneViewList
            closeAlert={this.closePopup}
            operationDetails={this.state.viewData}
          ></GeneViewList>
        </SweetAlert>
        {this.state.loader && (
          <div className="backdrop">
            <div className="loader">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FurtherAnalysis);

